import React, { useEffect, useState } from 'react'
import EahsForm from '../components/EahsForm'
import { useTranslate } from '../components/TranslationText'
import NetaqInput from '../components/NetaqInput';
import SimpleFileUpload from "../components/SimpleFileUpload";
import axiosInstance from '../axios/axios';
import { useLocation, useNavigate } from 'react-router';
import { formatDate } from '../helper/formatDate';
import Loader from '../components/Loader';
import { isEmail } from '../helper/Validations';
import { eformInput, noDataCard } from '../common/cssclasses';

export default function CourseEnrollment({ toast }) {
    const { translate } = useTranslate();
    const yesNoValues = [{ text: translate('web.yes', 'Yes'), value: true }, { text: translate('web.no', 'no'), value: false }];
    const [isSubmiting, setIsSubmitting] = useState(false);
    const [heightLsit, setHeightList] = useState([{ text: '155 cm - 160 cm', value: 0 }, { text: '160 cm - 165 cm', value: 1 }, { text: '165 cm - 170 cm', value: 2 }]);
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.has("Id")
        ? searchParams.get("Id")
        : '';
    const [form, setForm] = useState({ CourseId: id });
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [agreeOnTermsAndConditions, setAgreeOnTermsAndConditions] = useState(false);
    const [courseDetails, setCorseDetails] = useState({});
    const [loaded, setLoaded] = useState(false);




    const setPhoneNumber = (value) => {
        setForm((prev) => ({
            ...prev,
            'Phone': value
        }));
    }

    function handleChange(e) {
        setForm({
            ...form,
            [e?.target?.name]: e?.target?.value,
        })
    }
    const handleFilesUploaded = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            let checkFileSize = true;
            const fileListHook = [];

            for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
                if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
                    checkFileSize = false;
                    toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
                } else {
                    // Check allowed file types
                    const file = e.target.files[fileIndex];
                    const allowedMimeTypes = ['image/', 'application/pdf'];
                    if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
                        toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
                        continue; // Skip to the next file if type is not allowed
                    }
                    fileListHook.push({
                        documentFile: URL.createObjectURL(e.target.files[fileIndex]),
                        name: e.target.files[fileIndex].name,
                        file: e.target.files[fileIndex],
                    });
                }
            }

            setUploadedFiles(fileListHook);
        }
    };

    async function getCorseById() {
        try {
            const res = await axiosInstance.get(`/courses/getcoursebyid?id=${id}`);
            if (res.data?.responseCode == 200) {
                setCorseDetails(res.data?.result);
                setLoaded(true)
            }

        } catch (error) {
            console.error('error in get corse Details', error)
            setLoaded(true)
        }

    }

    async function getHeightRange() {
        try {
            const res = await axiosInstance.get('courses/getheightrange');

            if (res.status == 200) {
                const formattedData = res.data?.result.map((item) => ({
                    text: item?.displayName,
                    value: item?.id
                })) ?? [];
                setHeightList(formattedData);
            }
        } catch (error) {
            console.error('error in getting Height range');
        }
    }

    useEffect(() => {
        getCorseById();
        getHeightRange();
    }, [])

    //     GetCourses
    // GetHeightRange
    // SubmitCourseRegistration
    // GetCourseById
    function validateInputs() {
        if (!form?.FullName?.trim() ?? true) {
            toast.error(translate('web.theField', 'The Field') + " " + translate('web.FullNameEn', 'Full Name En') + " " + translate('web.isRequired', 'Is Required'));
            return false;
        }
        if (!form?.FullNameAr?.trim() ?? true) {
            toast.error(translate('web.theField', 'The Field') + " " + translate('web.FullNameAr', 'Name Ar') + " " + translate('web.isRequired', 'Is Required'));
            return false;
        }
        if (!form?.Email?.trim() ?? true) {
            toast.error(translate('web.theField', 'The Field') + " " + translate('web.Email', 'Email') + " " + translate('web.isRequired', 'Is Required'));
            return false;
        }
        if (!!form?.Email?.trim()) {
            if (!isEmail(form?.Email?.trim())) {
                toast.error(translate('web.theField', 'The Field') + " " + translate('web.Email', 'Email') + " " + translate('web.isNotValid', 'Is Not Valid'));
                return false;
            }
        }
        if (!form?.Phone?.trim() ?? true) {
            toast.error(translate('web.theField', 'The Field') + " " + translate('web.Phone', 'Phone') + " " + translate('web.isRequired', 'Is Required'));
            return false;
        }
        if (!isPhoneNumberValid ?? true) {
            toast.error(translate('web.theField', 'The Field') + " " + translate('web.Phone', 'Phone') + " " + translate('web.isNotValid', 'Is Not Valid'));
            return false;
        }
        if (form?.IsArabianHorseOwner == undefined ?? true) {
            toast.error(translate('web.theField', 'The Field') + " " + translate('web.areYouOwner', 'are You Owner') + " " + translate('web.isRequired', 'Is Required'));
            return false;
        }
        if (form?.IsArabianHorseOwner) {
            if (!form?.NumberOfHorses ?? true) {
                toast.error(translate('web.theField', 'The Field') + " " + translate('web.NumberOfOwenedHorses', 'Number Of Horses') + " " + translate('web.isRequired', 'Is Required'));
                return false;
            }
            if (form?.NumberOfHorses <= 0 ?? true) {
                toast.error(translate('web.theField', 'The Field') + " " + translate('web.NumberOfOwenedHorses', 'Number Of Horses') + " " + translate('web.isNotValid', 'is Not Valid'));
                return false;
            }
        }
        if (form?.HasEquestrianBackground == undefined ?? true) {
            toast.error(translate('web.theField', 'The Field') + " " + translate('web.HasEquestrianBackground', 'Has Equestrian Background') + " " + translate('web.isRequired', 'Is Required'));
            return false;
        }
        if (form?.HasPreviousCourseExperience == undefined ?? true) {
            toast.error(translate('web.theField', 'The Field') + " " + translate('web.HasPreviousCourseExperience', 'Has Previous Course Experience') + " " + translate('web.isRequired', 'Is Required'));
            return false;
        }
        if (form?.ParticipatingNow == undefined ?? true) {
            toast.error(translate('web.theField', 'The Field') + " " + translate('web.ParticipatingNow', 'Participating Now') + " " + translate('web.isRequired', 'Is Required'));
            return false;
        }
        if (form?.ParticipatingNow) {
            if (!form?.TrainingPlace?.trim() ?? true) {
                toast.error(translate('web.theField', 'The Field') + " " + translate('web.TrainingPlace', 'Training Place') + " " + translate('web.isRequired', 'Is Required'));
                return false;
            }
        }
        if (!form?.HeightRange ?? true) {
            toast.error(translate('web.theField', 'The Field') + " " + translate('web.HeightRange', 'Height Range') + " " + translate('web.isRequired', 'Is Required'));
            return false;
        }
        if (uploadedFiles.length <= 0 ?? true) {
            toast.error(translate('web.theField', 'The Field') + " " + translate('web.uploadYourId', 'upload Your Id') + " " + translate('web.isRequired', 'Is Required'));
            return false;
        }
        return true;
    }

    async function submit() {
        const isValid = validateInputs();
        if (!isValid || agreeOnTermsAndConditions == false) {
            return;
        }
        try {
            setIsSubmitting(true);
            const formData = new FormData();
            for (const [key, value] of Object.entries(form)) {
                if (value instanceof Object && 'value' in value) {
                    formData.append(key, value.value);
                } else {
                    formData.append(key, value);
                }
            }
            formData.append('IdentityFile', uploadedFiles[0]?.file ?? null)

            const res = await axiosInstance.post('/courses/submitcourseregistration', formData, {
                headers: {
                    'content-type': 'multipart/form-data',
                }
            });
            if (res.data?.responseCode == 200) {
                toast.success(translate('web.submittedSuccessfully', 'Submitted Successfully'));
                setIsSubmitting(false);
                navigate('/courses');

            }
        } catch (error) {
            setIsSubmitting(false);
            console.error('error in Submiting', error)
        }
    }


    return (
        <div className='container'>
            {!loaded ? <Loader /> :
                <>

                    <div className='row rtl'>
                        <h2 className='col-12 fw-bold'>
                            {courseDetails?.title}
                        </h2>
                        <div className='col-12 row'>
                            <div className="col-md-2  showDetaisLabel " style={{ width: 'unset' }}>
                                <i className="fa fa-calendar C89C66" style={{ margin: "0px 5px" }}></i>
                                {translate('web.startDate', 'Start Date')}:
                                <span className='ms-1'>{formatDate(courseDetails?.startDate)}</span>
                            </div>
                            <div className="col-md-2  showDetaisLabel " style={{ width: 'unset' }}>
                                <i className="fa fa-calendar C89C66" style={{ margin: "0px 5px" }}></i>
                                {translate('web.endDate', 'end Date')}:
                                <span className='ms-1'>{formatDate(courseDetails?.endDate)}</span>
                            </div>
                        </div>
                    </div>
                    {courseDetails?.isOpenedToRegister ?
                        <>
                            <EahsForm key={'Corse Form'} title={translate('web.personalData', 'Personal Data')}>
                                <div className={eformInput}>
                                    <NetaqInput
                                        type={'horseName'}
                                        name={'FullName'}
                                        label={translate('web.fullNameEn', 'Full Name En')}
                                        required={true}
                                        isJustEnglish
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={eformInput}>
                                    <NetaqInput
                                        type={'text'}
                                        name={'FullNameAr'}
                                        label={translate('web.FullNameAr', 'Name Ar')}
                                        required={true}
                                        onChange={handleChange}

                                    />
                                </div>
                                <div className={eformInput}>
                                    <NetaqInput
                                        type={'email'}
                                        name={'Email'}
                                        label={translate('web.Email', 'Email')}
                                        required={true}
                                        onChange={handleChange}

                                    />
                                </div>
                                <div className={eformInput}>
                                    <NetaqInput
                                        type={'phone'}
                                        name={'Phone'}
                                        label={translate('web.Phone', 'Phone')}
                                        required={true}
                                        onChange={setPhoneNumber}
                                        setIsPhoneNumberValid={setIsPhoneNumberValid}
                                    />
                                    {!isPhoneNumberValid &&
                                        <div className='text-danger'>
                                            {translate('web.PhoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                                        </div>}
                                </div>
                                <div className={eformInput}>
                                    <NetaqInput
                                        type={'select'}
                                        name={'IsArabianHorseOwner'}
                                        label={translate('web.areYouOwner', 'Are You Owner')}
                                        required={true}
                                        listSelect={yesNoValues}
                                        onChange={(selectedItem) => {
                                            setForm((prev) => {
                                                return {
                                                    ...prev,
                                                    IsArabianHorseOwner: selectedItem?.value
                                                }
                                            })
                                        }}
                                    />
                                </div>
                                {form?.IsArabianHorseOwner &&
                                    <div className={eformInput}>
                                        <NetaqInput
                                            type={'number'}
                                            name={'NumberOfHorses'}
                                            label={translate('web.NumberOfOwenedHorses', 'number Of Owned Horses')}
                                            required={true}
                                            minValue={1}
                                            onChange={handleChange}
                                        />
                                    </div>}
                                <div className={eformInput}>
                                    <NetaqInput
                                        type={'select'}
                                        name={'HasEquestrianBackground'}
                                        label={translate('web.HasEquestrianBackground', 'Background In Horse')}
                                        required={true}
                                        listSelect={yesNoValues}
                                        onChange={(selectedItem) => {
                                            setForm((prev) => {
                                                return {
                                                    ...prev,
                                                    HasEquestrianBackground: selectedItem?.value
                                                }
                                            })
                                        }}
                                    />
                                </div>
                                <div className={eformInput}>
                                    <NetaqInput
                                        type={'select'}
                                        name={'HasPreviousCourseExperience'}
                                        label={translate('web.HasPreviousCourseExperience', 'Participated In Similar Corses')}
                                        required={true}
                                        listSelect={yesNoValues}
                                        onChange={(selectedItem) => {
                                            setForm((prev) => {
                                                return {
                                                    ...prev,
                                                    HasPreviousCourseExperience: selectedItem?.value
                                                }
                                            })
                                        }}
                                    />
                                </div>
                                <div className={eformInput}>
                                    <NetaqInput
                                        type={'select'}
                                        name={'ParticipatingNow'}
                                        label={translate('web.ParticipatingNow', 'Participating Now')}
                                        required={true}
                                        listSelect={yesNoValues}
                                        onChange={(selectedItem) => {
                                            setForm((prev) => {
                                                return {
                                                    ...prev,
                                                    ParticipatingNow: selectedItem?.value
                                                }
                                            })
                                        }}
                                    />
                                </div>
                                {form?.ParticipatingNow &&
                                    <div className={eformInput}>
                                        <NetaqInput
                                            type={'text'}
                                            name={'TrainingPlace'}
                                            label={translate('web.TrainingPlace', 'Partipation Place')}
                                            required={true}
                                            onChange={handleChange}
                                        />
                                    </div>
                                }
                                <div className={eformInput}>
                                    <NetaqInput
                                        type={'select'}
                                        name={'HeightRange'}
                                        label={translate('web.HeightRange', 'Your Height')}
                                        required={true}
                                        listSelect={heightLsit}
                                        onChange={(selectedItem) => {
                                            setForm((prev) => {
                                                return {
                                                    ...prev,
                                                    HeightRange: selectedItem?.value
                                                }
                                            })
                                        }}
                                    />
                                </div>
                                <div className={eformInput}>
                                    <label>
                                        {translate('web.uploadYourId', 'Upload Your ID')}
                                    </label>
                                    <SimpleFileUpload
                                        label={translate('web.uploadYourId', 'Upload Your ID')}
                                        isMulti={false}
                                        required={true}
                                        initialFiles={uploadedFiles}
                                        isServer={false}
                                        onChange={handleFilesUploaded}
                                        accept={"image/*,application/pdf"}
                                        disabled={false}
                                    />
                                </div>
                            </EahsForm>
                            <EahsForm key={'termsAndConditions'} title={translate('web.termsAndConditions', 'Terms And Conditions')}>
                                <div className='col-12 '>
                                    <ul>
                                        {courseDetails?.termsList?.map((item) => (
                                            <li className='fw-bold'>
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className='col-12' style={{ paddingRight: 20, paddingLeft: 20 }}>
                                    <NetaqInput
                                        label={translate('web.iAgreeToTheTermsAndConditions', 'I Agree To The Terms And Conditions')}
                                        name='agreed'
                                        type='checkbox'
                                        onChange={(e) => {
                                            setAgreeOnTermsAndConditions(e.target.checked)
                                        }}
                                    />
                                </div>
                            </EahsForm>
                            <div className='row mt-4'>
                                <div className='col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 text-end ms-auto '>
                                    {isSubmiting ? <Loader /> :
                                        <div className={`btn btn-danger rounded px-5 ${agreeOnTermsAndConditions ? '' : 'disabled'}`} onClick={submit}>
                                            {translate('web.submit', 'Submit')}
                                        </div>
                                    }
                                </div>
                            </div>
                        </> : <>
                            <div className='row rtl mt-3' >
                                <div className={noDataCard}>
                                    <h4 className='text-danger text-center'>
                                        {translate('web.sorryRegistrationIsNotOpenNow', 'Sorry Registration Is Not Open Now')}
                                    </h4>
                                </div>
                            </div>
                        </>
                    }
                </>
            }
        </div>
    )
}
